import React from 'react'
import { Link } from 'react-router-dom'

function Corporate() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>Corporate </h1>
            <div className="sub_text">
              <p>
                Home -{" "}
                <a href="contact" className="primary-color">
                  Corporate
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle">
              <span>Tickling Tummy</span>
            </div>
            <h2>
              <span className="theme_color">
                Corporate & Institutional Catering
              </span>{" "}
              – Homemade Veg Meals for Teams, Schools & Tours in Coimbatore
            </h2>
          </div>
          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                If you're a corporate, startup, school, or travel agency in
                Coimbatore looking for wholesome, homemade vegetarian meals for
                your team or group, Tickling Tummy has you covered. From daily
                staff meals to snack boxes, school lunches, event catering, or
                travel group meals, we serve with love and scale—with the same
                homemade quality that defines us.
                <br />
                <br />
                Yes, our kitchen is home-style. But don’t let that fool
                you—we serve large teams, classrooms, and tour groups every
                day, and you'll be surprised it still tastes like it came from
                your mom’s kitchen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 1 - Image Left, Content Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix">
            {/* Image Left */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/corporate-catering-main.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/corporate-catering-main.jpg" alt="best budget lunch delivery" />
                </div>
              </div>
            </div>
            {/* Content Right */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInRight">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/corporate-catering-thumbnail.jpg" alt="tasty homemade lunch Coimbatore" />
                  </div>
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Who We Serve</span>
                    </div>
                    <div className="text">
                      <ul>
                        <li>◆ Corporate offices & startups – daily lunch, dinner, snacks</li>
                        <li>◆ Schools & colleges – staff meals, exam-time food packs, children's lunch programs</li>
                        <li>◆ Travel agencies & tour operators – packed group meals for tours and pilgrimages</li>
                        <li>◆ Event organizers – meetings, conferences, training sessions, and offsite retreats</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - Content Left, Image Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix flex-row-reverse">
            {/* Image Right */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInRight">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/institutional-catering-coimbatore.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/institutional-catering-coimbatore.jpg" alt="delicious veg meals Coimbatore" />
                </div>
              </div>
            </div>
            {/* Content Left */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInLeft">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/corporate-catering-thumbnail.jpg" alt="home taste lunch box" />
                  </div>
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>Why Institutions Choose Tickling Tummy</span>
                    </div>
                    <div className="text">
                      <ul>
                        <li>◆ Homemade & hygienic – zero preservatives, clean ingredients, made daily</li>
                        <li>◆ Customizable for dietary needs – low salt, no onion/garlic, diabetic-friendly, Jain-friendly</li>
                        <li>◆ Great for group travel – neatly packed meals for long journeys or religious tours</li>
                        <li>◆ Affordable pricing – for schools, companies, and tour operators</li>
                        <li>◆ Flexible logistics – pickup from R.S. Puram or delivery via partner networks</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 - Image Left, Content Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix">
            {/* Image Left */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/corporate-catering-event.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/corporate-catering-event.jpg" alt="traditional Tamil taste food" />
                </div>
              </div>
            </div>
            {/* Content Right */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInRight">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/corporate-catering-thumbnail.jpg" alt="Coimbatore tasty home food" />
                  </div>
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>What We Offer</span>
                    </div>
                    <div className="text">
                      <ul>
                        <li>◆ Daily Meal Plans - For office teams, schools, & staff</li>
                        <li>◆ Snack Boxes - For tea breaks, school kids, or events</li>
                        <li>◆ Event Catering - Corporate meets, seminars, orientation days</li>
                        <li>◆ Group Travel Meals - For tourism companies, yatras, and excursions</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4 - Content Left, Image Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix flex-row-reverse">
            {/* Image Right */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInRight">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/corporate-food-service.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/corporate-food-service.jpg" alt="mom’s style cooking Coimbatore" />
                </div>
              </div>
            </div>
            {/* Content Left */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInLeft">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/corporate-catering-thumbnail.jpg" alt="authentic Tamil homemade food" />
                  </div>
                  <div className="title-box centered">
                    <div className="subtitle">
                      <span>How to Get Started</span>
                    </div>
                    <div className="text">
                      <ul>
                        <li>◆ Tell us your group type – corporate, school, tour group, etc.</li>
                        <li>◆ Share the quantity and days required</li>
                        <li>◆ Customize your menu – soft food for seniors, spice-free for kids, or Jain-style packs</li>
                        <li>◆ Choose pickup or third-party delivery</li>
                        <li>◆ Sit back and enjoy consistent, homemade goodness—even in bulk</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Corporate
